import apiClient from './apiClient';

export async function listDelayed() {
  const res = await apiClient.get('/dispatch-analysis/delayed');
  return res.data.data.items;
}

export async function getBreakdown(dimension) {
  const res = await apiClient.get('/dispatch-analysis/breakdown', { params: { dimension } });
  return res.data.data.items;
}

export async function getYears() {
  const res = await apiClient.get('/dispatch-analysis/years');
  return res.data.data.items;
}

export async function getMonths(year) {
  const res = await apiClient.get('/dispatch-analysis/months', { params: { year } });
  return res.data.data.items;
}

export async function getDimensionDetail(year, month, dimension, range) {
  const params = { year, month, dimension };
  if (range && range.from) params.from = range.from;
  if (range && range.to) params.to = range.to;
  const res = await apiClient.get('/dispatch-analysis/dimension-detail', { params });
  return res.data.data;
}

export async function getComparison(dimension, periods) {
  const res = await apiClient.get('/dispatch-analysis/comparison', { params: { dimension, periods: JSON.stringify(periods) } });
  return res.data.data;
}

export async function getSalesMapCountries(year, month) {
  const res = await apiClient.get('/dispatch-analysis/sales-map/countries', { params: { year, month } });
  return res.data.data.items;
}

export async function getSalesMapStates(year, month, country) {
  const res = await apiClient.get('/dispatch-analysis/sales-map/states', { params: { year, month, country } });
  return res.data.data.items;
}

export async function getSalesMapCities(state, year, month, country) {
  const res = await apiClient.get('/dispatch-analysis/sales-map/cities', { params: { state, year, month, country } });
  return res.data.data.items;
}

export async function getSalesMapCustomers(city, year, month, country, state) {
  const res = await apiClient.get('/dispatch-analysis/sales-map/customers', { params: { city, year, month, country, state } });
  return res.data.data.items;
}

export async function getGrades() {
  const res = await apiClient.get('/dispatch-analysis/grades');
  return res.data.data;
}

export async function getTrend(weeks = 12) {
  const res = await apiClient.get('/dispatch-analysis/trend', { params: { weeks } });
  return res.data.data.items;
}

export async function getDayOfWeek() {
  const res = await apiClient.get('/dispatch-analysis/day-of-week');
  return res.data.data.items;
}

export async function refreshDispatchAnalysis() {
  const res = await apiClient.post('/dispatch-analysis/refresh');
  return res.data.data;
}

export async function getCustomerTracking() {
  const res = await apiClient.get('/dispatch-analysis/customer-tracking');
  return res.data.data;
}

export async function getCustomerHistory(customerId) {
  const res = await apiClient.get('/dispatch-analysis/customer-history', { params: { customerId } });
  return res.data.data;
}

export async function getRefPartyHistory(refPartyId) {
  const res = await apiClient.get('/dispatch-analysis/ref-party-history', { params: { refPartyId } });
  return res.data.data;
}
